// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__bsB19"};